/* ═══════════════════════════════════════════
   SWATCH IMAGE SWAP  v5 — Overlay approach
   Place in: assets/swatch-image-swap.js
   
   Works on:
   - Collection page cards (.card__media)
   - Featured collection cards (.fc__card-image)
   - Any card with .media container
   ═══════════════════════════════════════════ */

(function() {
  'use strict';

  function getCardMedia(swatch) {
    var card = swatch.closest('.card-wrapper')
            || swatch.closest('.fc__card')
            || swatch.closest('.card')
            || swatch.closest('li.grid__item');
    if (!card) return null;
    return card.querySelector('.card__media')
        || card.querySelector('.fc__card-image')
        || card.querySelector('.media');
  }

  function getOrCreateOverlay(mediaEl) {
    var existing = mediaEl.querySelector('.swatch-overlay-img');
    if (existing) return existing;

    var overlay = document.createElement('img');
    overlay.className = 'swatch-overlay-img';
    overlay.setAttribute('aria-hidden', 'true');
    overlay.style.cssText = 'position:absolute;top:0;left:0;width:100%;height:100%;object-fit:cover;z-index:2;opacity:0;transition:opacity 0.25s ease;pointer-events:none;';

    var pos = window.getComputedStyle(mediaEl).position;
    if (pos === 'static') {
      mediaEl.style.position = 'relative';
    }

    mediaEl.appendChild(overlay);
    return overlay;
  }

  function init() {
    var dots = document.querySelectorAll('.card-swatches__dot[data-variant-img]');
    
    dots.forEach(function(dot) {
      if (dot.dataset.v5Init) return;
      dot.dataset.v5Init = '1';

      var mediaEl = getCardMedia(dot);
      if (!mediaEl) return;

      var overlay = getOrCreateOverlay(mediaEl);

      dot.addEventListener('mouseenter', function() {
        var newSrc = this.dataset.variantImg;
        if (!newSrc) return;
        if (overlay.src !== newSrc) {
          overlay.src = newSrc;
        }
        overlay.style.opacity = '1';
      });

      dot.addEventListener('mouseleave', function() {
        overlay.style.opacity = '0';
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { setTimeout(init, 100); });
  } else {
    setTimeout(init, 100);
  }

  var grid = document.getElementById('product-grid');
  if (grid) {
    new MutationObserver(function() { setTimeout(init, 200); })
      .observe(grid, { childList: true, subtree: true });
  }

  document.addEventListener('shopify:section:load', function() { setTimeout(init, 200); });
})();